
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import Spinner from '../Spinner/Spinner';
import {
  CompareProductContainer,
  SpinnerContainer
} from './CompareProductStyleTypes';
import { removeProduct } from '../../../appState/ducks/comparison';
import { removeItemComparePopup } from '../../../appState/ducks/compareProducts';
import { CompareProduct } from './CompareProduct';

const ComparePopupContent = ({
  compareProductList,
  onRemoveItem,
  loading,
  onRemoveItemCompareBar,
  productSegmentId,
  productIdForFailedAddToBasket
}) => (
  <CompareProductContainer>
    {loading && <SpinnerContainer><Spinner /></SpinnerContainer>}
    {!loading && !isEmpty(compareProductList) && (
    <CompareProduct
      compareProductList={compareProductList}
      onRemoveItem={onRemoveItem}
      onRemoveItemCompareBar={onRemoveItemCompareBar}
      productSegmentId={productSegmentId}
      productIdForFailedAddToBasket={productIdForFailedAddToBasket}
    />
    )}
  </CompareProductContainer>
);

const mapStateToProps = (state) => {
  const { productIdForFailedAddToBasket } = state.general;
  const currentPageSegmentId =
      window.digitalData.page.category &&
      window.digitalData.page.category.segmentId;
  return {
    productIdForFailedAddToBasket,
    productSegmentId: currentPageSegmentId
  };
};

ComparePopupContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  compareProductList: PropTypes.objectOf(PropTypes.array).isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  onRemoveItemCompareBar: PropTypes.func.isRequired,
  productSegmentId: PropTypes.number.isRequired,
  productIdForFailedAddToBasket: PropTypes.string
};

ComparePopupContent.defaultProps = {
  productIdForFailedAddToBasket: null
};

export default connect(
  mapStateToProps,
  {
    onRemoveItem: removeItemComparePopup,
    onRemoveItemCompareBar: removeProduct
  }
)(ComparePopupContent);
